import React from 'react';
import { SOVEREIGN } from '../../utils/epcProjectVisual';
import { MyOrgUnit } from '../hooks/useActiveOrgUnit';

interface Props {
  items: MyOrgUnit[];
  activeOrgUnitId: string | null;
  onChange: (orgUnitId: string) => void;
}

export const DeptStrip: React.FC<Props> = ({ items, activeOrgUnitId, onChange }) => {
  if (items.length < 2) return null;
  return (
    <div
      className="flex flex-wrap items-center gap-1.5 px-5 py-2.5"
      style={{
        background: SOVEREIGN.canvas,
        borderBottom: `1px solid ${SOVEREIGN.cardBorder}`,
      }}
      role="tablist"
      aria-label="Departments"
    >
      {items.map((it) => {
        const isActive = String(it.orgUnitId) === String(activeOrgUnitId);
        return (
          <button
            key={it.orgUnitId}
            type="button"
            role="tab"
            aria-selected={isActive}
            onClick={() => onChange(it.orgUnitId)}
            className="rounded-lg px-3.5 py-1.5 text-[12.5px] font-semibold transition-all duration-150"
            style={
              isActive
                ? {
                    background: SOVEREIGN.btn,
                    color: '#fff',
                    boxShadow: SOVEREIGN.btnShadow,
                  }
                : {
                    background: SOVEREIGN.inputBg,
                    border: `1px solid ${SOVEREIGN.inputBorder}`,
                    color: SOVEREIGN.kpiCaption,
                  }
            }
            onMouseEnter={
              !isActive
                ? (e) => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = SOVEREIGN.brand;
                    (e.currentTarget as HTMLButtonElement).style.color = SOVEREIGN.bottle;
                  }
                : undefined
            }
            onMouseLeave={
              !isActive
                ? (e) => {
                    (e.currentTarget as HTMLButtonElement).style.borderColor = SOVEREIGN.inputBorder;
                    (e.currentTarget as HTMLButtonElement).style.color = SOVEREIGN.kpiCaption;
                  }
                : undefined
            }
          >
            {it.orgUnitName}
          </button>
        );
      })}
    </div>
  );
};

export default DeptStrip;
